import { IOmniaShell, react, SharedFieldsService } from "../../../omnia"
import { PlanApi } from "../../api"
import { PlanContext } from "../../context"
import { updateState } from "../../reducer"
import { createInitialState } from "../../state"
import { MapFactory, PlanState } from "../../types"
import { SoilAssessmentTable } from "../analysis/SoilAssessmentTable"
import { StdAnalysisTable } from "../analysis/StdAnalysisTable"
import { Fields } from "../fields/Fields"
import { MapView } from "../map/MapView"
import { Observations } from "../observations/Observations"
import { Timeline } from "../timeline/Timeline"
import { NewYear } from "../year/NewYear"
import { Commands } from "./Commands"

export interface MainProps {

    api: PlanApi
    fieldSvc: SharedFieldsService
    shell: IOmniaShell
    mapFactory: MapFactory
    version: number
    disableUi(disable: boolean): void

}

export function Main(props: MainProps) {

    const { api, version } = props
    const [state, dispatch] = React.useReducer(updateState, api, createInitialState)

    const context = React.useMemo(() => ({ dispatch, ...props }), [props, dispatch])

    const disableUi = useDisableShell(props.shell, state)

    React.useEffect(() => {
        props.disableUi(disableUi)
    }, [props.disableUi, disableUi])

    const apiData = react.useAsyncValue(() => api.load(false), [api, version])

    React.useEffect(() => {

        if (apiData) {
            dispatch({ type: "load", data: apiData })
        }

    }, [apiData])


    return <PlanContext.Provider value={context}>
        <Content state={state} disableUi={disableUi} />
    </PlanContext.Provider>

}


function Content({ state, disableUi }: { state: PlanState, disableUi: boolean }) {

    const { selectedField } = state

    const selectedFieldId = selectedField?.fieldId

    const props = { selectedFieldId, disableUi }

    return <>

        <div className="col1">

            <MapView {...props} />

            <Timeline {...props} />

        </div>

        <div className="col2">

            {
                (!disableUi) &&
                <NewYear state={state} />
            }

            <Fields state={state} disableUi={disableUi} />

            <div className="scrollable">

                {
                    selectedField &&
                    <>

                        <Observations state={state} />

                        <StdAnalysisTable field={selectedField} settings={state.settings.analysis} />

                        <SoilAssessmentTable field={selectedField} />

                        {/*
                            220608 - Not used anymore, healthy soil assessments are not included in soil mgmt plans
                            <HsaTable field={selectedField} />
                        */}

                    </>


                }

            </div>

            <Commands state={state} />

        </div>

    </>
}


function useDisableShell(shell: IOmniaShell, state: PlanState) {

    const { selectedField: field } = state
    const disable = field && field.valid && field.updated

    const target = {

        disableShell(disable: boolean) {
            return shell.disableShell(disable)
        },

        suspendRefresh() {
            return () => { }
        }

    }

    react.useDisableShell(target, disable)

    return disable

}
